import React from 'react';
import { useSeo } from '../hooks/useSeo';
import { Hero } from '../components/Hero';
import { DispatchCounter } from '../components/DispatchCounter';
import { FaqPreview } from '../components/FaqPreview';
import { UnderOneRoof } from '../components/UnderOneRoof';
import { DriveOrOffice } from '../components/DriveOrOffice';
import { BrokerVerification } from '../components/BrokerVerification';
import { CoreSupport } from '../components/CoreSupport';
import { NotJustBooking } from '../components/NotJustBooking';
import { CleanerOnboarding } from '../components/CleanerOnboarding';
import { FinalContact } from '../components/FinalContact';
export function Home() {
  useSeo({
    title: 'Truck Dispatch & Back Office Support for Owner-Operators | FSG Transport',
    description: 'FSG Transport provides U.S.-based truck dispatch, load planning, broker setup, paperwork, billing, and back-office support for owner-operators and small fleets.',
    path: '/'
  });
  return <div className="w-full" data-id="element-481">
      <Hero data-id="element-482" />
      <DispatchCounter data-id="element-483" />
      <FaqPreview data-id="element-484" />
      <UnderOneRoof data-id="element-485" />
      <DriveOrOffice data-id="element-486" />
      <BrokerVerification data-id="element-487" />
      <CoreSupport data-id="element-488" />
      <NotJustBooking data-id="element-489" />
      <CleanerOnboarding data-id="element-490" />
      <FinalContact data-id="element-491" />
    </div>;
}